import React from "react";
import { Checkbox } from "semantic-ui-react";

interface IBWInfolistStyleSwitch {
  isGreaterThanTablet: any;
  visible: boolean;
  isCardView: boolean;
  handleInfolistViewType: () => void;
}

const BWInfolistStyleSwitch = ({ visible, isGreaterThanTablet, isCardView, handleInfolistViewType }: IBWInfolistStyleSwitch) => {

  return (
    <React.Fragment>
    {visible ?
      <Checkbox 
        className="view-toggle" 
        toggle 
        label={{children: isCardView ? "Switch to table view!" : isCardView === false && isGreaterThanTablet === false ? "Switch to table view!" : "Switch to card view!" }} 
        onChange={() => handleInfolistViewType()} 
        defaultChecked={!isCardView}
      /> : <React.Fragment />
    }
    </React.Fragment>
  );
};

export default BWInfolistStyleSwitch;